import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space } from '../../theme/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: var(--layout-viewport-height, 100vh);
  background: ${semantic.bg.canvas};
  box-sizing: border-box;
  overflow-x: hidden;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
  }
`;

export const Hero = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    width: 45%;
    height: var(--layout-viewport-height, 100vh);
    position: sticky;
    top: var(--announcement-banner-height, 0px);
    flex-shrink: 0;
    align-self: flex-start;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${space['space-800']} ${space['space-200']} 0;
  flex: 1;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 55%;
    padding: ${space['space-1000']} ${space['space-1000']} 0;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: center;
  margin-top: ${space['space-1600']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-2000']};
  }
`;

export const CenteredContent = styled.div`
  width: 100%;
  max-width: 545px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-800']};

  & > h1 {
    font-size: ${fonts.size['2xl']};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    gap: ${space['space-1000']};

    & > h1 {
      font-size: ${fonts.size['3xl']};
    }
  }
`;

export const StepBody = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const CalendarScroll = styled.div`
  width: 100%;
  height: calc(
    var(--layout-viewport-height, 100vh) - 19rem - var(--sticky-footer-offset-bottom, 0px)
  );
  padding: 0 ${space['space-300']};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  button > span > span:first-child {
    font-size: ${fonts.size.base};
  }

  > div > div:first-child > span {
    font-size: ${fonts.size.base};
  }

  [data-no-nav] {
    font-size: ${fonts.size.base};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: calc(
      var(--layout-viewport-height, 100vh) - 23rem - var(--sticky-footer-offset-bottom, 0px)
    );
    padding: 0 ${space['space-1000']};
  }
`;

export const BottomBar = styled.div`
  width: 100%;
  padding: ${space['space-600']} ${space['space-600']};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.subtle};
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--sticky-footer-offset-bottom, var(--shell-mobile-nav-height, 0px));
  background: ${semantic.bg.canvas};
  display: flex;
  justify-content: center;
  z-index: 103;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    left: auto;
    right: auto;
    bottom: 0;
    padding: ${space['space-600']} 0;
    z-index: 10;
  }
`;

export const BottomBarInner = styled.div`
  width: 100%;
  max-width: 680px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${space['space-400']};
`;

export const SkipButton = styled.button`
  margin-right: auto;
  background: none;
  border: none;
  padding: ${space['space-200']} ${space['space-300']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  cursor: pointer;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
    border-radius: ${size.radius['radius-sm']};
  }

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:disabled {
    color: ${semantic.text.tertiary};
    cursor: not-allowed;
  }
`;
